import OddsBtn, { useRedirectConfirmationModal } from "@/components/oddsBtn";
import { SPORTSBOOK_URL } from "@/constants/amplitude";
import { NFL } from "@/constants/sports";
import RedirectToSportsbook from "@/events/Modals/RedirectToSportsbookModal";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import { MarketName, Team } from "./SingleMarketCard";
import { formatOddString } from "./utils";
import styles from "./lineChart.module.scss";

interface SingleMarketTeamProps {
  team: Team;
  toggle: boolean;
  market: MarketName;
}

const SingleMarketTeam = ({ team, toggle, market }: SingleMarketTeamProps) => {
  let open = formatOddString(team.odds[0]);
  if (toggle && market === "Spread") {
    open = formatOddString(team.line?.[0]);
  }
  if (toggle && market === "Total") {
    open = team.line?.[0]?.toString() ?? "-";
  }

  const { eventName } = useHeadToHeadContext();
  const { onOddsClick, redirectToSportsbookProps } =
    useRedirectConfirmationModal(NFL, eventName, "line_movement");

  return (
    <div className={styles.teamInfo}>
      <div className={styles.teamText}>
        <div className={styles.team}>
          <div
            className={styles.teamColor}
            style={{ backgroundColor: team.color }}
          />{" "}
          {team.name}
        </div>
        <div className={styles.open}>Open: {open}</div>
      </div>
      <RedirectToSportsbook {...redirectToSportsbookProps} />
      <OddsBtn
        classButton={styles.oddsButton}
        classHandicap={styles.oddsHandicap}
        handicap={team.oddsButtonData?.formattedHandicap}
        isSuspended={!team.oddsButtonData?.odds}
        onClick={() => {
          onOddsClick(team.oddsButtonData?.url ?? SPORTSBOOK_URL);
        }}
        odds={team.oddsButtonData?.odds ?? "-"}
      />
    </div>
  );
};

export default SingleMarketTeam;
